export default {
  CANCEL_BUTTON: 'frontend.global.operation.cancel',
  CONFIRM_BUTTON: 'frontend.global.operation.confirm'
};
